// extracted by mini-css-extract-plugin
export default {"container":"NextAvailability_container__LOyyl","empty-message":"NextAvailability_empty-message__fBcc3","next-availability-button":"NextAvailability_next-availability-button__+FSQd"};